// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination-module--pagination--7aaYj","newerButtonWrapper":"pagination-module--newerButtonWrapper--2RFXK"};